<div class="banner d-none d-lg-flex" role="banner">
  <div class="container fantasy-banner">
    <h1>{{ 'games.page.pick.player.title' | translate }}</h1>

    <div class="d-flex align-items-center">
      <span class="text-white me-lg-3 me-1 font-size-12">Presented By: </span>
      <img class="sponsor-logo" src="assets/images/games/FMBanner.png" />
    </div>
  </div>
</div>
<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<div class="container mt-3">
  <ng-container
    *ngIf="
      {
        pendingGames: pendingGames$ | async,
        currentGames: currentGames$ | async
      } as games;
      else noGames
    "
  >
    <ng-container *ngIf="!!games.currentGames.length || !!games.pendingGames.length; else noGames">
      <ng-container *ngIf="games.currentGames && !!games.currentGames.length">
        <div class="row">
          <div class="col-lg-6 col-12">
            <fgb-fantasy-game-panel
              [game]="games.currentGames[0]"
              (button)="goToDetail(games.currentGames[0].GameId)"
              [buttonState]="hasActivePlayer(games.currentGames[0]) ? 'player-link' : 'no-player-link'"
            ></fgb-fantasy-game-panel>
          </div>
          <div class="col-lg-6 col-12 d-lg-block d-none">
            <div *ngIf="games.currentGames[1]; else noGame">
              <fgb-fantasy-game-panel-next-game [game]="games.currentGames[1]"> </fgb-fantasy-game-panel-next-game>
            </div>
            <ng-template #noGame>
              <div class="no-game-panel card border d-flex align-items-center justify-content-center bg-info">
                <h4 class="text-white mb-0">{{ 'pick.player.game.panel.placeholder' | translate }}</h4>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <div class="row">
    <div class="col-lg-6 col-12">
      <h5 class="font-heading mt-lg-4 mt-3 mb-2 text-uppercase">{{ 'pick.player.history.title' | translate }}</h5>
      <fgb-fantasy-history-list> </fgb-fantasy-history-list>
    </div>

    <div class="col-lg-6 col-12">
      <h5 class="font-heading mt-4 mb-2 text-uppercase">{{ 'pick.player.leaderboard.title' | translate }}</h5>

      <fgb-leaderboard [toShow]="5" [isWidget]="true" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
    </div>
  </div>

  <!--Placeholder Information-->
  <ng-template #noGames>
    <div class="d-flex align-items-center bg-white justify-content-center no-game-card">
      {{ 'fantasy.game.no.games.text' | translate }}
    </div>
  </ng-template>

  <!--Rules-->
  <h5 class="text-start mt-3">{{ 'pick.player.rules.title' | translate }}</h5>
  <div class="col-12 games-rules-container mt-lg-3">
    <div class="row">
      <div ngbAccordion #a="ngbAccordion" [destroyOnHide]="true" [closeOthers]="true" class="w-100 mt-lg-0">
        <div ngbAccordionItem id="ngb-panel-0">
          <div ngbPanelHeader>
            <h2 ngbAccordionHeader class="mt-0">
              <button class="rules-button" ngbAccordionButton>{{ 'pick.player.rules1.title' | translate }}</button>
            </h2>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <div class="row py-0">
                <div class="content col-12">
                  <div class="fantasy">
                    <div
                      class="font-size-14"
                      [innerHTML]="'pick.player.rules1.description' | translate | markdownTranslate"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ngbAccordionItem id="ngb-panel-1">
          <div ngbPanelHeader>
            <h2 ngbAccordionHeader class="mt-0">
              <button class="rules-button" ngbAccordionButton>{{ 'pick.player.rules2.title' | translate }}</button>
            </h2>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <div class="row">
                <div class="content col-12">
                  <div class="fantasy">
                    <div
                      class="font-size-14"
                      [innerHTML]="'pick.player.rules2.description' | translate | markdownTranslate"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ngbAccordionItem id="ngb-panel-2">
          <div ngbPanelHeader>
            <h2 ngbAccordionHeader class="mt-0">
              <button class="rules-button" ngbAccordionButton>{{ 'pick.player.rules3.title' | translate }}</button>
            </h2>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <div class="row">
                <div class="content col-12">
                  <div class="fantasy">
                    <div
                      class="font-size-14"
                      [innerHTML]="'pick.player.rules3.description' | translate | markdownTranslate"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
